import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from '@ovComponents/2-component/accordion/accordion';
import { Typography } from 'hephaestus/web';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { useLocalization } from '../../../../../../hooks/useLocalization';

export const CalculatorDisclaimer = ({
  options,
}: {
  options: Record<string, unknown>;
}) => {
  const { translateBackendString } = useLocalization();
  const title = translateBackendString(options.disclaimerTitle);
  const description = translateBackendString(options.disclaimerDescription);

  return (
    <Accordion
      sx={{ '.MuiAccordionSummary-root': { borderTop: 'none !important' } }}
      data-testid='calculator-disclaimer'
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant='bodyMedium' sx={{ fontWeight: 600 }}>
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        {description ? (
          <ReactMarkdown remarkPlugins={[remarkGfm]} linkTarget='_blank'>
            {description}
          </ReactMarkdown>
        ) : null}
      </AccordionDetails>
    </Accordion>
  );
};
